var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16449_1433",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 12,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0918 1H6.5V22.1836H17.0918V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16449_1433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2039 22.1836V12.2437H6.5V8.66469H9.2039V5.60796C9.2039 3.20588 10.801 1 14.4812 1C15.9713 1 17.0732 1.13886 17.0732 1.13886L16.9863 4.4809C16.9863 4.4809 15.8627 4.47027 14.6364 4.47027C13.3093 4.47027 13.0965 5.06478 13.0965 6.05155V8.66469H17.0918L16.9179 12.2437H13.0965V22.1836H9.2039Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.b6c340085367814b67f5f2986762ef88.svg";
export { ForwardRef as ReactComponent };